export enum PageStatisticsActionTypes {
  GET_PAGE_STATISTICS_REQUEST = 'page-statistics/GET_PAGE_STATISTICS_REQUEST',
  GET_PAGE_STATISTICS_SUCCESS = 'page-statistics/GET_PAGE_STATISTICS_SUCCESS',
  GET_PAGE_STATISTICS_ERROR = 'page-statistics/GET_PAGE_STATISTICS_ERROR',
  GET_PAGE_STATISTICS_MONTH_REQUEST = 'page-statistics/GET_PAGE_STATISTICS_MONTH_REQUEST',
  GET_PAGE_STATISTICS_MONTH_SUCCESS = 'page-statistics/GET_PAGE_STATISTICS_MONTH_SUCCESS',
  GET_PAGE_STATISTICS_MONTH_ERROR = 'page-statistics/GET_PAGE_STATISTICS_MONTH_ERROR',
}
